import methods from "../Service";
import useHttpParamsJsonCreate from "hooks/useHttpParamsJsonCreate";
const useParamsJson = (param) => { return useHttpParamsJsonCreate(param); }
const ComprobanteTipo = {

   // async Get(qs) { return await methods.Get("AtencionAlumno/GetById" + useParamsJson(qs)) },
    async Get() { return await methods.Get("ComprobanteTipo/Get" ) },
    async Post(data) { return await methods.Post("ComprobanteTipo/Post", data) },
    async Put(qs, data) { return await methods.Put("ComprobanteTipo/Put" + useParamsJson(qs), data) },
    async Delete(qs) { return await methods.Delete("ComprobanteTipo/Delete" + useParamsJson(qs)) }
};

export default ComprobanteTipo;